<template>
  <button
    :style="buttonStyle"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    @mousedown="isActive = true"
    @mouseup="isActive = false"
  >
    {{ name }}
  </button>
</template>
  
  <script>
export default {
  name: "BaseButton",
  props: {
    width: {
      type: String,
      default: "176px",
    },
    height: {
      type: String,
      default: "44px",
    },
    backgroundColor: {
      type: String,
      default: "#056DE8",
    },
    name: {
      type: String,
      default: "确定",
    },
  },
  data() {
    return {
      isHovered: false,
      isActive: false,
    };
  },
  computed: {
    buttonStyle() {
      let currentColor = this.backgroundColor;
      if (this.isActive) {
        currentColor = this.darkenColor(currentColor, 0.1); // 点击时颜色变深
      } else if (this.isHovered) {
        currentColor = this.lightenColor(currentColor, 0.1); // 悬停时颜色变浅
      }
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: this.width,
        height: this.height,
        backgroundColor: currentColor,
        borderColor: currentColor,
        color: "#ffffff",
        border: "none",
        borderRadius: "12px",
        cursor: "pointer",
        outline: "none",
        transition: "background-color 0.3s ease",
      };
    },
  },
  methods: {
    // 深化颜色
    darkenColor(color, amount) {
      const c = this.hexToRgb(color);
      return `rgb(${Math.max(c.r - amount * 255, 0)}, ${Math.max(
        c.g - amount * 255,
        0
      )}, ${Math.max(c.b - amount * 255, 0)})`;
    },
    // 浅化颜色
    lightenColor(color, amount) {
      const c = this.hexToRgb(color);
      return `rgb(${Math.min(c.r + amount * 255, 255)}, ${Math.min(
        c.g + amount * 255,
        255
      )}, ${Math.min(c.b + amount * 255, 255)})`;
    },
    // 将十六进制颜色转换为 RGB
    hexToRgb(hex) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return { r, g, b };
    },
  },
};
</script>
  
  <style scoped>
button {
  font-family: inherit;
  font-size: 16px;
  padding: 0;
  overflow: hidden;
  text-align: center;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
}
</style>